import { actionTypes } from './actionTypes'
import { calculateFilters, findDefaultOption } from './_helpers'

const createColumn = (id, availableColumns) => {
  const column = availableColumns.find(x => x.id === id)
  return { ...column, option: findDefaultOption(column.type), value: null, logic: 0 }
}

export const reducer = (state, action, prefix, availableColumns) => {
  switch (action.type) {
    case actionTypes(prefix).load: return { ...state, entity: { ...action.payload, isDirty: false } }
    case actionTypes(prefix).addColumn: return { ...state, entity: { ...state.entity, isDirty: true, columns: [...state.entity.columns, createColumn(action.payload, availableColumns)]} }
    case actionTypes(prefix).removeColumn: return { ...state, entity: { ...state.entity, isDirty: true, columns: state.entity.columns.filter((_, idx) => idx !== action.payload) } }
    case actionTypes(prefix).updateColumn: return { ...state, entity: { ...state.entity, isDirty: true, columns: state.entity.columns.map((x, idx) => {
      if (idx === action.payload.index) {
        const { index, ...delta } = action.payload
        return { ...x, ...delta }
      }
      return x
    }) } }
    case actionTypes(prefix).update: return { ...state, entity: { ...state.entity, ...action.payload, isDirty: true } }
    case actionTypes(prefix).applyFilter: return { ...state, staticFilter: calculateFilters(action.payload) }
    case actionTypes(prefix).clearFilters: return { ...state, entity: { ...state.entity, isDirty: true, columns: state.entity.columns.map(x => ({ ...x, value: null }))} }
    case actionTypes(prefix).updating: return { ...state, updating: action.payload }

    default: return state
  }
}